import { Button } from "antd";
import { Modal } from "antd";
import { FC } from "react";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ResubmissionProcedureCghs from "./ResubmissionProcedureCghs";

type ResubmissionCghsProps = {
  resubmissionCghs: boolean;
  closeResubmissionCghsModal: any;
  handleCancel: () => void;
  handleSubmit: any;
  isFetchingPortalData: boolean;
  resubmissionProcedure: any;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  patientDetails: IFetchAllDetails | null;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: CallableFunction;
  form: any;
};

const ResubmissionCghs: FC<ResubmissionCghsProps> = (props) => {
  return (
    <Modal
      open={props?.resubmissionCghs}
      title="New Resubmission Case"
      centered
      width={1200}
      loading={props?.isFetchingPortalData}
      footer={[
        <Button key="back" onClick={props?.closeResubmissionCghsModal}>
          Cancel
        </Button>,

        <Button
          type="primary"
          htmlType="submit"
          style={{
            border: "1px solid darkcyan",
            background: "darkcyan",
            fontSize: "14px",
            fontWeight: "400",
            color: "white",
          }}
          onClick={props?.handleSubmit}
        >
          SUBMIT
        </Button>,
      ]}
      onCancel={props?.closeResubmissionCghsModal}
      style={{ top: 20 }}
      className="new-add-enhancement"
    >
      <ResubmissionProcedureCghs
        resubmissionProcedure={props?.resubmissionProcedure}
        formattedAccreditationOptions={props?.formattedAccreditationOptions}
        formattedTreatingDoctorsOptions={props?.formattedTreatingDoctorsOptions}
        formattedProcedureReferral={props?.formattedProcedureReferral}
        formattedProceduresOptions={props?.formattedProceduresOptions}
        handleGetProcedureAmount={props?.handleGetProcedureAmount}
        handleGetProcedureStrats={props?.handleGetProcedureStrats}
        patientDetails={props?.patientDetails}
        procedureStrats={props?.procedureStrats}
        handleDeleteProcedure={props?.handleDeleteProcedure}
        isModalOpen={props?.isModalOpen}
        setIsModalOpen={props?.setIsModalOpen}
        handleOk={props?.handleOk}
        handleCancel={props?.handleCancel}
        form={props?.form}
      />
    </Modal>
  );
};

export default ResubmissionCghs;
